import { QueryClient } from '@tanstack/react-query';

// Low-level retries on 5xx and transient network errors now live in api-service
// (see services/retry-policy.ts). At this layer we keep retry off for anything
// already-handled there so we don't compound 3 inner × 2 outer = 6 attempts.
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
			retry: (failureCount, error) => {
				if (error instanceof Error) {
					const message = error.message;
					// 4xx — never retry; client errors are deterministic.
					if (/^API error 4\d\d:/.test(message)) {
						return false;
					}
					// 5xx — api-service already retried with backoff. Don't compound.
					if (/^API error 5\d\d:/.test(message)) {
						return false;
					}
				}
				// Anything else (unexpected runtime errors, fetch throws that escaped
				// api-service): one cautious retry. Failed queries are NOT cached as
				// data — TanStack stores the error in `error`, leaving `data` from the
				// last successful response intact (or undefined on first load).
				return failureCount < 1;
			},
			refetchOnWindowFocus: false,
			refetchOnReconnect: true,
			throwOnError: false, // Prevent crashes from query errors
		},
		mutations: {
			retry: (failureCount, error) => {
				// Mutations are usually non-idempotent (POST). api-service's default
				// disables retry for POST unless caller opts in; do not add another
				// layer of retry here.
				if (error instanceof Error) {
					const message = error.message;
					if (/^API error \d\d\d:/.test(message)) {
						return false;
					}
				}
				return failureCount < 1;
			},
			throwOnError: false, // Prevent crashes from mutation errors
		},
	},
});